import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MiniProfileCard from "../MiniProfileCard";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import ContactsOfSiteInput from "./ContactsOfSiteInput";
import ZoneDropDownInput from "./ZoneDropDownInput";
import ContractInputForSite from "./ContractInputForSite";
import AssistanceInputForSite from "./AssistanceInputForSite";
import MapWithDraggableMarker from "../../../map/MapWithDraggableMarker";
import MapWithDraggableMarker2 from "../../../map/MapWithDraggableMarker2";
import Context from "../../../../Context";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import { useTranslation } from "react-i18next";
import { FiPlus, FiTrash2 } from "react-icons/fi";

const initialLocation = { lat: 5.3484, lng: -4.0268 };

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 800px;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  width: 100%;
  border-radius: 15px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const MapSection = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 15px;
  overflow: hidden;
`;

let dropDownStyle = { flex: 1 };

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PillButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border);
  background: var(--gradientSurface);
  color: var(--element);
  padding: 10px 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--lightShadow);

  &:hover {
    background: var(--accent);
    color: var(--mainBackground);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

const ModalCard = styled.div`
  background: var(--surfaceSolid);
  border: 1px solid var(--borderDim);
  border-radius: 16px;
  padding: 24px;
  width: min(520px, 100%);
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ModalTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--element);
  font-weight: 700;
  font-size: 18px;

  span {
    color: var(--elementDim);
    font-weight: 500;
    font-size: 14px;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const ModalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ModalSelect = styled.select`
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  color: var(--element);
  font-weight: 600;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 12px;
  color: var(--element);
  font-weight: 600;
`;

export default function AddOrEditSite({}) {
  const { t } = useTranslation();

  const { refreshPreloadedData, loggedInUser } = useContext(Context);
  const [itemID, setItemID] = useState(null);
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("ADD");
  const [forcedMapUpdateCode, setForcedMapUpdateCode] = useState("random123");
  const [customFields, setCustomFields] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [activeModal, setActiveModal] = useState(null); // 'add' | 'delete' | null
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldType, setNewFieldType] = useState("text");
  const [newFieldOptions, setNewFieldOptions] = useState("");

  const canManageCustomFields =
    loggedInUser?.accountType?.toUpperCase() === "DEVELOPER";

  useEffect(() => {
    try {
      let cached = localStorage.getItem("cs-custom-fields-site");
      if (cached) {
        let parsed = JSON.parse(cached);
        if (parsed.definitions) setCustomFields(parsed.definitions);
        if (parsed.values) setCustomFieldValues(parsed.values);
      }
    } catch (e) {
      console.log("Unable to read cached custom fields", e);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(
        "cs-custom-fields-site",
        JSON.stringify({
          definitions: customFields,
          values: customFieldValues,
        })
      );
    } catch (e) {
      console.log("Unable to persist custom fields", e);
    }
  }, [customFields, customFieldValues]);

  useEffect(() => {
    let newItemID = getUrlQuery("itemID");
    setItemID(newItemID);

    if (newItemID) setPurpose("UPDATE");
  }, []);

  useEffect(() => {
    if (purpose == "UPDATE") {
      setLoading(true);
      if (itemID) {
        loadItemToBeEdited();
      }
    } else {
      let newItem = { ...item };
      newItem.latitude = initialLocation.lat;
      newItem.longitude = initialLocation.lng;

      setItem(newItem);
    }
  }, [itemID]);

  const fieldTypeOptions = [
    { value: "text", label: "Texte" },
    { value: "number", label: "Nombre" },
    { value: "date", label: "Date" },
    { value: "textarea", label: "Texte long" },
    { value: "select", label: "Liste déroulante" },
    { value: "radio", label: "Boutons radio" },
  ];

  function upsertCustomField() {
    if (!newFieldName.trim()) return window.popupAlert("Nom du champ requis");

    let cleanedName = newFieldName.trim();
    let options = newFieldOptions
      .split(",")
      .map((opt) => opt.trim())
      .filter(Boolean);

    if (
      (newFieldType === "select" || newFieldType === "radio") &&
      options.length === 0
    ) {
      return window.popupAlert("Ajoutez au moins une option");
    }

    setCustomFields((prev) => {
      const existingIndex = prev.findIndex(
        (field) => field.name.toLowerCase() === cleanedName.toLowerCase()
      );

      let next = [...prev];
      let newField = {
        name: cleanedName,
        type: newFieldType,
        options,
      };

      if (existingIndex !== -1) {
        next[existingIndex] = newField;
      } else {
        next.push(newField);
      }
      return next;
    });

    setActiveModal(null);
    setNewFieldName("");
    setNewFieldOptions("");
    setNewFieldType("text");
  }

  function removeCustomField(name) {
    setCustomFields((prev) => prev.filter((field) => field.name !== name));
    setCustomFieldValues((prev) => {
      let copy = { ...prev };
      delete copy[name];
      return copy;
    });
  }

  function handleCustomFieldChange(fieldName) {
    return (e) => {
      let value = e?.target ? e.target.value : e;
      setCustomFieldValues((prev) => ({ ...prev, [fieldName]: value }));
    };
  }

  function renderCustomFields() {
    if (!customFields.length) return null;

    return (
      <InputItems>
        <Row style={{ flexWrap: "wrap", gap: "20px" }}>
          <CustomLabel>Champs personnalisés</CustomLabel>
          {customFields.map((field) => (
            <div key={field.name} style={{ minWidth: "240px", flex: "1" }}>
              {renderCustomFieldInput(field)}
            </div>
          ))}
        </Row>
      </InputItems>
    );
  }

  function renderCustomFieldInput(field) {
    if (field.type === "select" || field.type === "radio") {
      let options = (field.options || []).map((opt) => ({
        value: opt,
        label: opt,
      }));

      return (
        <DropDownInput
          style={{ minWidth: "240px" }}
          options={options}
          label={field.name}
          value={customFieldValues[field.name]}
          onChange={handleCustomFieldChange(field.name)}
        />
      );
    }

    if (field.type === "textarea") {
      return (
        <MaterialInput
          multiline
          rows={3}
          label={field.name}
          value={customFieldValues[field.name] || ""}
          onChange={handleCustomFieldChange(field.name)}
        />
      );
    }

    let inputType = "text";
    if (field.type === "number") inputType = "number";
    if (field.type === "date") inputType = "date";

    return (
      <MaterialInput
        label={field.name}
        type={inputType}
        value={customFieldValues[field.name] || ""}
        onChange={handleCustomFieldChange(field.name)}
      />
    );
  }

  function renderCustomFieldModals() {
    if (!activeModal) return null;

    if (activeModal === "add")
      return (
        <ModalOverlay>
          <ModalCard>
            <ModalTitle>
              Ajouter / modifier un champ
              <span>Personnalisez le formulaire du site.</span>
            </ModalTitle>

            <ModalRow>
              <MaterialInput
                label={"Nom du champ"}
                value={newFieldName}
                onChange={(e) => setNewFieldName(e.target.value)}
              />
            </ModalRow>

            <ModalRow>
              <ModalSelect
                value={newFieldType}
                onChange={(e) => setNewFieldType(e.target.value)}
              >
                {fieldTypeOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </ModalSelect>
            </ModalRow>

            {(newFieldType === "select" || newFieldType === "radio") && (
              <ModalRow>
                <MaterialInput
                  label={"Options (séparées par des virgules)"}
                  value={newFieldOptions}
                  onChange={(e) => setNewFieldOptions(e.target.value)}
                />
              </ModalRow>
            )}

            <ModalActions>
              <CustomButton surfaceColor="var(--surface2)" onClick={() => setActiveModal(null)}>
                Annuler
              </CustomButton>
              <CustomButton onClick={upsertCustomField}>Enregistrer</CustomButton>
            </ModalActions>
          </ModalCard>
        </ModalOverlay>
      );

    if (activeModal === "delete")
      return (
        <ModalOverlay>
          <ModalCard>
            <ModalTitle>
              Supprimer un champ
              <span>Retirez les champs personnalisés devenus inutiles.</span>
            </ModalTitle>

            <Chips>
              {customFields.length === 0 ? (
                <span style={{ color: "var(--elementDim)" }}>
                  Aucun champ personnalisé pour le moment.
                </span>
              ) : (
                customFields.map((field) => (
                  <Chip key={field.name}>
                    {field.name}
                    <PillButton
                      style={{ padding: "6px 10px" }}
                      onClick={() => removeCustomField(field.name)}
                    >
                      <FiTrash2 />
                    </PillButton>
                  </Chip>
                ))
              )}
            </Chips>

            <ModalActions>
              <CustomButton onClick={() => setActiveModal(null)}>Fermer</CustomButton>
            </ModalActions>
          </ModalCard>
        </ModalOverlay>
      );
  }

  function getHeaderActions() {
    if (!canManageCustomFields) return null;

    return (
      <HeaderActions>
        <PillButton onClick={() => setActiveModal("add")}>
          <FiPlus />
          Ajouter / modifier un champ
        </PillButton>
        <PillButton onClick={() => setActiveModal("delete")}>
          <FiTrash2 />
          Supprimer un champ
        </PillButton>
      </HeaderActions>
    );
  }


  let titleLine1 = "Ajout";
  let titleLine2 = "D'un Site";

  if (purpose == "UPDATE") {
    titleLine1 = "Modifier";
    titleLine2 = "Le profil de la personne";
  }

  let coreContent = <LoadingSection />;
  const isSiteActive = item.isActive !== false;

  if (!loading) {
    coreContent = (
      <Container>
        {/* {getItemBeingEditedCard()} */}

        <Inputs>
          <UploadSection>
            <ImagePicker
              forPerson={true}
              value={item.image}
              onChange={updateField("image", true)}
            ></ImagePicker>
          </UploadSection>

          <MapSection>
            <MapWithDraggableMarker2
              forcedMapUpdateCode={forcedMapUpdateCode}
              value={getLocationValue()}
              onChange={(newVal) => {
                setItem((existingItem) => {
                  existingItem = { ...existingItem };
                  existingItem.latitude = newVal.lat;
                  existingItem.longitude = newVal.lng;

                  return existingItem;
                });
              }}
            />

            {/* <MapWithDraggableMarker
              pinPosition={{ lat: item.latitude, long: item.longitude }}
              setPinPosition={(newVal) => {
                let newItem = { ...item };
                newItem.latitude = newVal.lat;
                newItem.longitude = newVal.lng;
                setItem(newItem);
              }}
            /> */}
          </MapSection>
          <InputItems>
            <CustomLabel>Details</CustomLabel>
            <Row>
              <MaterialInput
                label={"Nom du client"}
                // placeholder={"Type Email Here"}
                value={item.clientName}
                onChange={updateField("clientName")}
              />
              <MaterialInput
                // label={"Nom du lieu"}
                label={"Nom de code"}
                // placeholder={"Type Email Here"}
                value={item.placeName}
                onChange={updateField("placeName")}
              />

              {/* <MaterialInput
                  label={"Codename"}
                  // placeholder={"Type Email Here"}
                  value={item.codename}
                  onChange={updateField("codename")}
                /> */}
            </Row>

            <Row>
              <MaterialInput
                type="number"
                label={"Latitude"}
                value={parseFloat(item.latitude)}
                onChange={updateField("latitude")}
              />

              <MaterialInput
                type="number"
                label={"Longitude"}
                value={parseFloat(item.longitude)}
                onChange={updateField("longitude")}
              />

              <CustomCheckbox
                type="number"
                label={"Actif"}
                value={item.isActive}
                onChange={updateField("isActive", true)}
              />
            </Row>

            <Row>
              <MaterialInput
                type="date"
                label={"Date de mise en place"}
                value={item.dateOfImplementation}
                onChange={updateField("dateOfImplementation")}
                disabled={!isSiteActive}
              />
              <MaterialInput
                type="date"
                label={"Date de fin"}
                value={item.contractEndDate}
                onChange={updateField("contractEndDate")}
                disabled={isSiteActive}
              />
            </Row>
          </InputItems>

          <InputItems>
            <ContactsOfSiteInput
              label="contacts"
              value={item.contacts}
              onChange={updateField("contacts", true)}
            />
          </InputItems>

          <InputItems>
            <CustomLabel>Emplacement</CustomLabel>

            <Row>
              <ZoneDropDownInput
                style={{ maxHeight: "70px" }}
                label={"Zone"}
                // placeholder={"Type Email Here"}
                value={item.zoneID}
                onChange={updateField("zoneID", true)}
              />

              <MaterialInput
                multiline={true}
                rows={4}
                label={"Adresse Commune"}
                // placeholder={"Type Email Here"}
                value={item.addressLocality}
                onChange={updateField("addressLocality")}
              />

              <MaterialInput
                multiline={true}
                rows={4}
                label={"Adresse Rue"}
                // placeholder={"Type Email Here"}
                value={item.addressStreet}
                onChange={updateField("addressStreet")}
              />
            </Row>

            <Row>
              <MaterialInput
                multiline={true}
                rows={4}
                label={"Directions à suivre"}
                // placeholder={"Type Email Here"}
                value={item.directionToFollow}
                onChange={updateField("directionToFollow")}
              />
            </Row>
          </InputItems>

          <InputItems>
            <ContractInputForSite
              label="Contrats"
              value={item.contracts}
              onChange={updateField("contracts", true)}
            />
          </InputItems>

          <InputItems>
            <ContractInputForSite
              label="Holiday/Weekend Staff"
              value={item.holidayStaff}
              onChange={updateField("holidayStaff", true)}
            />
          </InputItems>

          <InputItems>
            <AssistanceInputForSite
              options={[
                { value: "BIPPER", label: "Bipper" },
                {
                  value: "ANTI_INTRUSION_ALARM",
                  label: "Alarme Anti Intrusion",
                },
                { value: "CAMERA", label: "Camera" },
                { value: "Other", label: "Autre" },
              ]}
              label={"Assistance Technique"}
              // placeholder={"Type Email Here"}
              value={item.assistance}
              onChange={updateField("assistance", true)}
            />
          </InputItems>

          <InputItems>
            <Row>
              <MaterialInput
                multiline={true}
                rows={4}
                label={"Instructions spéciales"}
                // placeholder={"Type Email Here"}
                value={item.specialInstructions}
                onChange={updateField("specialInstructions")}
              />
            </Row>
          </InputItems>
          {renderCustomFields()}
          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE" ? "Modifier le site" : "Ajouter le site"}
            </CustomButton>
          </Buttons>
        </Inputs>
      </Container>
    );
  }

  return (
    <PermissionGuard
      permissionName={"sitePermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
        rightSlot={getHeaderActions()}
      >
        {coreContent}
      </LoggedInBoilerplate>
      {renderCustomFieldModals()}
    </PermissionGuard>
  );

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      setItem((newItem) => {
        newItem = { ...item };
        if (dontUseEventValue) {
          newItem[fieldName] = e;
        } else {
          newItem[fieldName] = e.target.value;
        }

        return newItem;
      });

      setTimeout(() => {
        if (fieldName == "latitude" || fieldName == "longitude") {
          setForcedMapUpdateCode(Math.random() * 1000);
        }
      }, []);
    };
  }

  function getLocationValue() {
    if (!item.latitude) return initialLocation;
    if (!item.longitude) return initialLocation;

    let lat = parseFloat(item.latitude);
    let lng = parseFloat(item.longitude);

    if (isNaN(lat)) return initialLocation;
    if (isNaN(lng)) return initialLocation;

    return { lat: lat, lng: lng };
  }

  function save() {
    const validationError = validateSiteDatesBeforeSubmit();
    if (validationError) {
      window.popupAlert(validationError);
      return;
    }

    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  function validateSiteDatesBeforeSubmit() {
    if (!item.dateOfImplementation || !item.contractEndDate) return null;

    let startDate = new Date(item.dateOfImplementation);
    let endDate = new Date(item.contractEndDate);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return null;

    let startDay = Date.UTC(
      startDate.getUTCFullYear(),
      startDate.getUTCMonth(),
      startDate.getUTCDate()
    );

    let endDay = Date.UTC(
      endDate.getUTCFullYear(),
      endDate.getUTCMonth(),
      endDate.getUTCDate()
    );

    if (endDay < startDay) {
      return "La date de fin doit être supérieure ou égale à la date de mise en place.";
    }

    return null;
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/site/?itemID=${itemID}`);

    setItem(data);
    if (data.customFieldDefinitions) setCustomFields(data.customFieldDefinitions);
    if (data.customFieldValues) setCustomFieldValues(data.customFieldValues);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/site", {
        image: item.image,
        clientName: item.clientName,
        placeName: item.placeName,
        zoneID: item.zoneID,
        codename: item.codename,
        longitude: item.longitude,
        isActive: item.isActive,
        latitude: item.latitude,
        contractEndDate: item.contractEndDate,
        contacts: item.contacts,
        dateOfImplementation: item.dateOfImplementation,
        contracts: item.contracts,
        holidayStaff: item.holidayStaff,
        assistance: item.assistance,
        addressLocality: item.addressLocality,
        addressStreet: item.addressStreet,

        directionToFollow: item.directionToFollow,
        specialInstructions: item.specialInstructions,
        customFieldValues,
        customFieldDefinitions: customFields,
      });

      await refreshPreloadedData();
      // goTo(`/site/${res._id}`)();
      goTo(`/sites`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/site", {
        itemID,
        changes: {
          codename: item.codename,
          image: item.image,
          clientName: item.clientName,
          placeName: item.placeName,
          zoneID: item.zoneID,
          longitude: item.longitude,
          latitude: item.latitude,
          isActive: item.isActive,
          contacts: item.contacts,
          contractEndDate: item.contractEndDate,
          dateOfImplementation: item.dateOfImplementation,
          contracts: item.contracts,
          holidayStaff: item.holidayStaff,
          assistance: item.assistance,
          addressLocality: item.addressLocality,
          addressStreet: item.addressStreet,
          directionToFollow: item.directionToFollow,
          specialInstructions: item.specialInstructions,
          customFieldValues,
          customFieldDefinitions: customFields,
        },
      });

      await refreshPreloadedData();

      window.popupAlert(t("done"));
      // goTo(`/site/${res._id}`)();
      goTo(`/sites`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
